import * as React from 'react'

import './MaintenanceBanner.scss'

interface IProps {
  title: string
  description: string
}

export default ({ title, description }: IProps) => {
  return (
    <div className="MaintenanceBanner">
      <span>
        <strong>{title}</strong>&nbsp;{description}
      </span>
    </div>
  )
}
